import script from "./BottomNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomNav.vue?vue&type=script&setup=true&lang=ts"

import "./BottomNav.vue?vue&type=style&index=0&id=43aedb2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43aedb2c"]])

export default __exports__